module.exports = __webpack_public_path__ + "static/media/mobilePhone.21d00621.png";